import Vue from "vue";
import Datetime from "./vue-datetime.esm";
import "./vue-datetime.css";

Vue.use(Datetime);
Vue.component('DateTime', Datetime);
